// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__3eZVY","title":"Container_title__58Tg5"};